// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchType_bckdrp__qD9at {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background-color: transparent;
  z-index: 1;
}
.SearchType_searchTypeSpan__I7jxD {
  position: absolute;
  top: calc(50% - 12px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-inline-start: calc(100% - 23px);
  cursor: pointer;
  color: #979797;
  fill: #979797;
  transition: all 0.2s ease-out;
}
.SearchType_searchTypeSpan__I7jxD:hover {
  color: #5a5a5a;
  fill: #5a5a5a;
}

.SearchType_menuContainer__3VeMY {
  position: absolute;
  top: calc(100% + 4px);
  z-index: 2;
  box-shadow: 0px 0px 20px 3px #c5c5c556;
  border-radius: 8px;
  padding-block: 10px;
  padding-inline-start: 5px;
  padding-inline-end: 15px;
  background-color: #fff;
}
.SearchType_mounted__1qyZ4 {
  animation: SearchType_inAnimationx__nRJP4 250ms ease-in;
}
.SearchType_unmounted__dVuvM {
  animation: SearchType_outAnimationx__BQ0Gv 270ms ease-out forwards;
}
@keyframes SearchType_inAnimationx__nRJP4 {
  0% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
}
@keyframes SearchType_outAnimationx__BQ0Gv {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/NewTable/TableColumnSearchInputs/SearchType.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,eAAe;EACf,cAAc;EACd,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,uDAAqC;AACvC;AACA;EACE,kEAAgD;AAClD;AACA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF","sourcesContent":[".bckdrp {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  height: 100vh;\r\n  background-color: transparent;\r\n  z-index: 1;\r\n}\r\n.searchTypeSpan {\r\n  position: absolute;\r\n  top: calc(50% - 12px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-inline-start: calc(100% - 23px);\r\n  cursor: pointer;\r\n  color: #979797;\r\n  fill: #979797;\r\n  transition: all 0.2s ease-out;\r\n}\r\n.searchTypeSpan:hover {\r\n  color: #5a5a5a;\r\n  fill: #5a5a5a;\r\n}\r\n\r\n.menuContainer {\r\n  position: absolute;\r\n  top: calc(100% + 4px);\r\n  z-index: 2;\r\n  box-shadow: 0px 0px 20px 3px #c5c5c556;\r\n  border-radius: 8px;\r\n  padding-block: 10px;\r\n  padding-inline-start: 5px;\r\n  padding-inline-end: 15px;\r\n  background-color: #fff;\r\n}\r\n.mounted {\r\n  animation: inAnimationx 250ms ease-in;\r\n}\r\n.unmounted {\r\n  animation: outAnimationx 270ms ease-out forwards;\r\n}\r\n@keyframes inAnimationx {\r\n  0% {\r\n    opacity: 0;\r\n    visibility: hidden;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    visibility: visible;\r\n  }\r\n}\r\n@keyframes outAnimationx {\r\n  0% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    visibility: hidden;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bckdrp": `SearchType_bckdrp__qD9at`,
	"searchTypeSpan": `SearchType_searchTypeSpan__I7jxD`,
	"menuContainer": `SearchType_menuContainer__3VeMY`,
	"mounted": `SearchType_mounted__1qyZ4`,
	"inAnimationx": `SearchType_inAnimationx__nRJP4`,
	"unmounted": `SearchType_unmounted__dVuvM`,
	"outAnimationx": `SearchType_outAnimationx__BQ0Gv`
};
export default ___CSS_LOADER_EXPORT___;
